import React from "react";
import styled from "styled-components";
import { useNavigate } from 'react-router-dom';

const Pcontainer = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f9f9f9;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 800px;
  width: 90%;
  max-height: 80vh;
  padding: 30px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  overflow: hidden; /* Keeps the container tidy */
`;

const ScrollBox = styled.div`
  flex-grow: 1;
  overflow-y: auto;
  margin: 20px 0;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 4px;
  line-height: 1.6;
  color: #333;
  font-size: 0.9rem;
  background: #fafafa;
`;

const CenteredH1 = styled.h1`
  text-align: center;
  margin-top: 0;
  color: #222;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  margin-top: 10px;
`;

const Button = styled.button`
  padding: 12px 24px;
  background-color: ${props => props.secondary ? '#6c757d' : '#007bff'};
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: bold;
  transition: opacity 0.2s;

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

function PrivacyPolicy() {
  const navigate = useNavigate();

  return (
    <Pcontainer>
      <Container>
        <CenteredH1>Privacy Policy</CenteredH1>

        <ScrollBox>
          <strong>Summary:</strong> StatTracker collects only the information needed to run your account and improve the service. We do not sell your personal information, and we never collect payment or betting account details.

          <h3>1. Information We Collect</h3>
          <p><strong>Account information:</strong> When you create an account, we collect your email address, username, and a securely hashed version of your password.</p>
          <p><strong>Usage information:</strong> We collect information about how you use StatTracker, such as pages viewed, players or teams you follow, saved preferences, and features you interact with.</p>
          <p><strong>Device information:</strong> We may automatically collect your IP address, browser type, operating system, and general (city or region level) location.</p>

          <h3>2. How We Use Your Information</h3>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Create and maintain your account</li>
            <li>Save your preferences, watchlists, and settings</li>
            <li>Operate, maintain, and improve our models and features</li>
            <li>Send important service notices, such as changes to these policies</li>
            <li>Detect and prevent fraud, abuse, or security issues</li>
            <li>Verify that users meet our age requirement</li>
          </ul>

          <h3>3. Cookies and Tracking</h3>
          <p>We use cookies and similar technologies to keep you signed in, remember your preferences, and understand how the site is used. You can disable cookies in your browser settings, but some features may not work properly without them.</p>

          <h3>4. How We Share Information</h3>
          <p>We do not sell or rent your personal information. We may share information only in the following situations:</p>
          <ul>
            <li><strong>Service providers:</strong> Trusted vendors who help us operate the site (e.g., hosting, analytics, email delivery), who may only use your data to provide services to us.</li>
            <li><strong>Legal requirements:</strong> When required by law, subpoena, or to protect the rights, safety, or property of StatTracker or others.</li>
            <li><strong>Business transfers:</strong> If StatTracker is involved in a merger, acquisition, or sale of assets, your information may be transferred as part of that transaction.</li>
          </ul>

          <h3>5. Third-Party Links and Sportsbooks</h3>
          <p>StatTracker may contain links to third-party websites. We are not responsible for the privacy practices of those sites, and we do not receive or store any information about wagers you place on third-party platforms. Please review their privacy policies before providing them any information.</p>

          <h3>6. Data Security</h3>
          <p>We use reasonable technical and organizational measures to protect your information, including encrypted connections (HTTPS) and hashed passwords. However, no method of transmission or storage is 100% secure, and we cannot guarantee absolute security.</p>

          <h3>7. Data Retention</h3>
          <p>We keep your account information for as long as your account is active. If you delete your account, we will delete or anonymize your personal information within a reasonable period, except where we are required to keep it for legal or security purposes.</p>

          <h3>8. Your Rights and Choices</h3>
          <p>Depending on where you live, you may have the right to access, correct, delete, or request a copy of your personal information, and to opt out of certain uses of it. To make a request, contact us using the information below. We will not discriminate against you for exercising these rights.</p>

          <h3>9. Age Restriction</h3>
          <p>StatTracker is intended only for users 18 and older (21+ in certain jurisdictions). We do not knowingly collect information from anyone under 18. If we learn that we have collected information from a minor, we will delete it promptly.</p>

          <h3>10. Changes to This Policy</h3>
          <p>We may update this Privacy Policy from time to time. When we do, we will update the "Last updated" date below and, for significant changes, notify you by email or through the site.</p>

          <h3>11. Contact Us</h3>
          <p>If you have questions about this Privacy Policy or your information, contact us at <strong>contact@stattracker.biz</strong>.</p>

          <p><em>Last updated: November 2026</em></p>
        </ScrollBox>

        <ButtonGroup>
          <Button secondary onClick={() => navigate(-1)}>Back</Button>
        </ButtonGroup>
      </Container>
    </Pcontainer>
  );
}

export default PrivacyPolicy;